import React from "react";
import { useNavigate } from "react-router-dom";
import { ModalTitle } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { CompanyShortNameApi } from "../Utils/Axios.jsx";

// "Log In" popup on the public website: asks for the company service name
// and sends the user to that company's login page.
const CompanyLoginModal = ({ onClose }) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      companyName: "",
    },
  });

  const closeModal = () => {
    reset();
    onClose();
  };

  // Prevent a leading space
  const handleKeyDown = (e) => {
    if (e.target.value.trim() !== "") {
      return;
    }
    if (e.keyCode === 32) {
      e.preventDefault();
    }
  };

  // Only allow lowercase letters
  const toInputLowerCase = (e) => {
    const inputValue = e.target.value;
    let newValue = "";
    for (let i = 0; i < inputValue.length; i++) {
      const char = inputValue.charAt(i);
      if (char.match(/[a-z]/)) {
        newValue += char;
      }
    }
    e.target.value = newValue;
  };

  const onSubmit = async (data) => {
    const { companyName } = data;

    try {
      // Call API to validate the company short name
      const response = await CompanyShortNameApi(companyName);

      if (response.data.data) {
        localStorage.setItem("companyName", companyName);
        navigate(`/${companyName}/login`, { state: { branding: response.data.data } });
        closeModal();
      }
    } catch (error) {
      const message = error?.response?.data?.error?.message || "Validation failed.";
      toast.error(message);
      console.error("Validation error:", message);
    }
  };

  return (
    <div
      className="modal"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between w-100">
            <ModalTitle className="modal-title">Company Service Name</ModalTitle>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeModal}
            >
              X{" "}
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <input
                type="text"
                name="companyName"
                className="form-control"
                placeholder="Enter Company Service Name"
                onInput={toInputLowerCase}
                onKeyDown={handleKeyDown}
                {...register("companyName", {
                  required: "Company Service Name is Required",
                  pattern: {
                    value: /^[a-z]+$/,
                    message:
                      "This field accepts only lowercase alphabetic characters without spaces",
                  },
                  minLength: {
                    value: 2,
                    message: "Minimum 2 Characters Required",
                  },
                  maxLength: {
                    value: 30,
                    message: "Maximum 30 Characters allowed",
                  },
                })}
              />
              {errors.companyName && (
                <p className="errorMsg">{errors.companyName.message}</p>
              )}
              <div className="modal-footer" style={{ paddingRight: "0px" }}>
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyLoginModal;
